import { useMemo } from "react";
import useFetchGraphData from "../useFetchGraphData";
import { parseLocalDate } from "../../utils";

/**
 * Fetch & shape data for the photic-zone nutrient-ratio chart.
 */
export default function useNutrientRatioSeries({
  startDate,
  endDate,
  locationid,
}) {
  const {
    data,
    isFetching: isLoading,
    isError,
  } = useFetchGraphData(
    {
      start_date: startDate,
      end_date: endDate,
      locationid: String(locationid),
    },
    "depth-profile-additional-ratio-graph-data-crosstabbed"
  );

  const { series } = useMemo(() => {
    if (!data?.length) return { series: {} };

    const pts = data.map((d) => ({
      x: parseLocalDate(d.rdate),
      tn_tp: d.tn_tp ?? null,
      tdn_tdp: d.tdn_tdp ?? null,
      tin_srp: d.tin_srp ?? null,
      chla: d.chla ?? null,
      lmt: d.lmt ?? null,
    }));

    return {
      series: {
        tn_tp: pts.map((p) => ({ x: p.x, y: p.tn_tp })),
        tdn_tdp: pts.map((p) => ({ x: p.x, y: p.tdn_tdp })),
        tin_srp: pts.map((p) => ({ x: p.x, y: p.tin_srp })),
        chla: pts.map((p) => ({ x: p.x, y: p.chla })),
        lmt: pts.map((p) => ({ x: p.x, y: p.lmt })),
      },
    };
  }, [data]);

  return { series, isLoading, isError };
}
